import { render } from "./form-validation.vue?vue&type=template&id=2b5dc08a"
import script from "./form-validation.vue?vue&type=script&lang=js"
export * from "./form-validation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__